if (!customElements.get('noble-origins-sticky')) {
  customElements.define(
    'noble-origins-sticky',
    class extends HTMLElement {
      connectedCallback() {
        this.selectionEl = this.querySelector('[data-noble-sticky-selection]');
        this.priceEl = this.querySelector('[data-noble-sticky-price]');
        this.compareEl = this.querySelector('[data-noble-sticky-compare]');
        this.saveEl = this.querySelector('[data-noble-sticky-save]');
        this.button = this.querySelector('[data-noble-sticky-button]');
        this.buttonPriceEl = this.querySelector('[data-noble-sticky-button-price]');
        this.imageEl = this.querySelector('[data-noble-sticky-image]');

        this.onScroll = () => this.updateVisibility();
        this.onPlanChange = () => this.sync();
        this.onVariantChange = (event) => {
          this.syncImage(event.detail?.variant);
          this.sync();
        };
        this.onButtonClick = () => {
          const submit = this.submitButton();
          if (!submit || submit.disabled) return;
          submit.click();
        };

        this.button?.addEventListener('click', this.onButtonClick);
        document.addEventListener('noble-origins:plan-change', this.onPlanChange);
        document.addEventListener('noble-origins:variant-change', this.onVariantChange);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        this.sync();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onButtonClick);
        document.removeEventListener('noble-origins:plan-change', this.onPlanChange);
        document.removeEventListener('noble-origins:variant-change', this.onVariantChange);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      submitButton() {
        return document.querySelector('.noble-origins-buy__submit');
      }

      text(element) {
        return element?.textContent?.replace(/\s+/g, ' ').trim() || '';
      }

      setHidden(element, value) {
        if (!element) return;
        element.hidden = !value;
        element.textContent = value || '';
      }

      sync() {
        const submit = this.submitButton();
        const options = Array.from(document.querySelectorAll('.noble-origins-variant__options'))
          .map((fieldset) => {
            const input = fieldset.querySelector('input:checked');
            return this.text(input?.closest('label')?.querySelector('.noble-origins-variant__name'));
          })
          .filter(Boolean);
        const plan = document.querySelector('.noble-origins-plan.is-selected');
        const frequency = this.text(plan?.querySelector('.noble-origins-plan__frequency-option.is-selected span'));
        const planName = this.text(plan?.querySelector('.noble-origins-plan__title'));
        const detail = frequency ? frequency.split('|')[0].trim() : planName;
        if (this.selectionEl) this.selectionEl.textContent = [...options, detail].filter(Boolean).join(', ');

        const price = this.text(plan?.querySelector('[data-subscription-price], [data-one-time-price]'));
        const compareNode = plan?.querySelector('[data-subscription-compare]');
        const compare = compareNode && !compareNode.hidden ? this.text(compareNode) : '';
        const saveNode = plan?.querySelector('[data-save-badge]');
        const save = saveNode && !saveNode.hidden ? this.text(saveNode) : '';
        const buttonPrice = this.text(submit?.querySelector('[data-buy-price]')) || price;

        if (this.priceEl) this.priceEl.textContent = price;
        this.setHidden(this.compareEl, compare);
        this.setHidden(this.saveEl, save);
        if (this.buttonPriceEl) this.buttonPriceEl.textContent = buttonPrice;
        if (this.button) this.button.disabled = Boolean(submit?.disabled);
      }

      syncImage(variant) {
        if (!this.imageEl || !variant?.image) return;
        this.imageEl.src = variant.image;
        if (variant.imageAlt) this.imageEl.alt = variant.imageAlt;
      }

      updateVisibility() {
        const submit = this.submitButton();
        if (!submit) return;
        const scrolledPastButton = submit.getBoundingClientRect().bottom <= 0;
        const atPageBottom =
          window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
        this.classList.toggle('has-sticky', scrolledPastButton && !atPageBottom);
      }
    }
  );
}
